var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.data.images.data.length === 1 ? 'single' : 'multiple',
    _vm.data.imageplacement || 'center',
    _vm.data.type === 'grid' ? 'normal' : _vm.data.type,
    { 'images-after': _vm.imagesAfter },
    { 'images-before': _vm.imagesBefore } ]},[_c('Media',{attrs:{"data":_vm.data.images.data,"type":_vm.data.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }